module.exports = __webpack_public_path__ + "static/media/icon-upload-white.4e9723e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/icons/icon-upload-white.svg
// module id = 352
// module chunks = 0